import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import MoreActionMenu from "./MoreActionMenu";
import "./userdetailsheader.scss";
import { userInfoFetch, formatName } from "../../utlis/commonFunction";
import { getCurrentLocale } from "../../utlis/locale";

const UserDetailsHeader = ({
  children,
  fromSuccessbackHandler,
  removeReportId,
}) => {
  console.log("fromSuccessbackHandler", fromSuccessbackHandler);
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  const backArrowHandler = () => {
    navigate(-1);

    //setting this as empty because once user click back button/ enters from back page. we have generate new reportID
    if (removeReportId) {
      if (urlPath === "/rom-details") {
        sessionStorage.setItem("romReportId", "");
        sessionStorage.setItem("romStatus", "");
      }
    }
  };

  //this useeffect used for clearing session storage, when the user back from browser or phone back
  useEffect(() => {
    if (urlPath === "/test-module") {
      sessionStorage.setItem("romReportId", "");
      sessionStorage.setItem("romStatus", "");
    }
  }, [urlPath]);

  return (
    <div className="user-detail-menu-wrapper">
      <div className="pinned-header">
        <div className="header-left">
          <button
            className="back-btn"
            onClick={() => backArrowHandler()}
            aria-label="Back"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 12H5m0 0l7-7m-7 7l7 7"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="user-info">
            <img
              src={userInfoFetch()?.picture}
              className="user-avatar"
              alt="user"
            />
            <div className="user-details">
              <Typography className="user-name">
                {formatName(userInfoFetch(), getCurrentLocale())}
              </Typography>
              <Typography className="user-meta">
                {userInfoFetch()?.gender}
                {userInfoFetch()?.age > 0 && ` | ${userInfoFetch()?.age}`}
              </Typography>
            </div>
          </div>
        </div>
        <div className="header-right">
          <MoreActionMenu userInfo={userInfoFetch()} />
        </div>
      </div>

      <div className="user-details-content">{children}</div>
    </div>
  );
};

export default UserDetailsHeader;
